var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dot",class:{ 'is-deployed': _vm.isDeployed }})
}
var staticRenderFns = []

export { render, staticRenderFns }